import React, { Fragment } from 'react';
import { Panel } from '../../../components/containers/Panel';
import { SettingsTeamMember, SettingsWorkspace } from '../../../models/settings-pages';
import { Table } from '../../../components/containers/Table';
import { Tbody } from '../../../components/containers/Table/Tbody';
import { Tr } from '../../../components/containers/Table/Tr';
import { Td } from '../../../components/containers/Table/Td';
import { formatTimezoneToDisplay } from '../../../helpers/timeFormatter';
import { ContainerListItem } from '../../../components/actions/ListItem/ListItem.view';
import { PanelHeader } from '../../../components/containers/Panel/PanelHeader.view';
import { SocialProfile } from '../../../components/socialProfiles/SocialProfile';
import classes from './WorkspaceCard.module.scss';
import { ButtonMenu } from '../../../components/actions/ButtonMenu';
import { useUserRole } from '../../../hooks/useUserRole';
import { UserOrganizationRole } from '../../../models/graphql';
import { profilesHelpers } from '../Profiles/Profiles.helpers';
import { Debugger } from '../../../components/containers/Debugger';

export type WorkspaceCardViewProps = {
  workspace: SettingsWorkspace;
  organizationMembers: SettingsTeamMember[];
  editWorkspaceAction: () => void;
  deleteWorkspaceAction: () => void;
  isLastWorkspace: boolean;
};

export const WorkspaceCardView = (props: WorkspaceCardViewProps): JSX.Element => {
  const { selectedOrgRole } = useUserRole();
  const MembersTableRows = props.organizationMembers?.map(member => {
    const teamUserName: string = member.status !== 'invited' ? member.name : member.email;
    const isInWorkspace: boolean = member.workspaces?.includes(props.workspace?.id || '') || false;

    return (
      <Fragment key={`container-${member.status}-${member.id}`}>
        {isInWorkspace && (
          <Tr key={`member-access-${member.id}`}>
            <Td style={['shaded', 'one-line']}>{teamUserName}</Td>
            <td>{member.role}</td>
          </Tr>
        )}
      </Fragment>
    );
  });

  const squareButtonMenuListItems: ContainerListItem[] = [
    {
      action: props.editWorkspaceAction,
      label: 'Edit Workspace'
    }
  ];

  // Prevent deletion of workspaces for now https://app.asana.com/1/705860248814339/project/712232507015260/task/1209143319029741?focus=true
  // if (!props.isLastWorkspace) {
  //   squareButtonMenuListItems.push({
  //     action: props.deleteWorkspaceAction,
  //     label: 'Delete Workspace'
  //   });
  // }

  const profiles = props.workspace.profiles?.map(profile => (
    <div key={profile.id} className={classes.ProfileWrapper}>
      <SocialProfile
        size={'large'}
        socialProfile={profilesHelpers.remapSocialProfile(profile, false, false, false)}
        image={profile.photoUrl}
        disconnected={!profile.connected}
      />
    </div>
  ));

  const dotMenu =
    !props.isLastWorkspace ||
    selectedOrgRole === UserOrganizationRole.ADMIN ||
    selectedOrgRole === UserOrganizationRole.OWNER ? (
      <ButtonMenu
        isSquareButton={true}
        buttonType={'transparent'}
        side={'right'}
        listItems={squareButtonMenuListItems}
      />
    ) : null;

  return (
    <Panel key={`workspace-card-${props.workspace?.id}`}>
      <Debugger tooltipContent={'Workspace ID: ' + props.workspace.id} modalContent={props.workspace} />
      <PanelHeader
        title={props.workspace?.name}
        subTitle={formatTimezoneToDisplay(props.workspace.timezone)}
        squareButtonMenu={dotMenu}
      />
      <div className={'cell small-6 margin-bottom-small-32'}>
        <h6 className={'uppercase margin-bottom-small-16'}>Workspace Permissions</h6>
        <Table tableStyle={'stacked_scrolling'}>
          <Tbody>{MembersTableRows}</Tbody>
        </Table>
      </div>
      {profiles && profiles.length > 0 && (
        <div className={'cell small-6 margin-bottom-small-32'}>
          <h6 className={'uppercase margin-bottom-small-16'}>Profiles</h6>
          <div className={classes.Profiles}>
            <div className={'grid-x grid-padding-x'}>{profiles}</div>
          </div>
        </div>
      )}
    </Panel>
  );
};
